import { comma } from '@/components/mixins/comma'
import { auth } from '@/components/mixins/auth.js';
import { imageUpload } from '@/components/mixins/post.js';
export const myProfile = {
    data(){
        return{
            user_nic: {
                val: this.$store.getters.currentUser.nic,
                isValid: true,
            },
            password: {
                val: '',
                isValid: true,
            },     
            password_confirmation: {
                val: '',
                isValid: true,
            },  
            recommender:{
                val: null,
                isModify: false,    
            },
            isLoading:{
                default:true,
            }      
        }
    },
    mixins:[ comma,auth,imageUpload ],
    computed:
    {
        userInfo(){
            return this.$store.getters.currentUser;
        }
    },
    mounted(){
        this.getPassword();
    },
    methods:{
        async changeNic($event)
        {     
            //아이템 유무 확인 있으면 사용유무를 묻고 없으면 구매유무를 확인한다.    
            const ckitem =  await this.ckItem('change_nic','','','닉네임 변경');
            if(!ckitem){  
                return;                          
            }else{
                //아이템이 있을시
                if($event.target.readOnly === true)
                {
                    if(confirm('닉네임 변경은 아이템이 필요합니다.\n아이템을 사용하시겠습니까?'))
                    {
                        $event.target.readOnly = false;
                        $event.target.style.background = "#fff";
                    }
                }                
            }              
        },
        async getPassword()
        {           
            try {
                //추천인 정보도 함께 가져온다.
               const response = await this.$store.dispatch("users/getPassword", {user_id: this.userInfo.id});               
                //console.log(response);      
                this.password.val= response.pw;      
                this.password_confirmation.val= response.pw;   
                this.recommender.val = response.friend; 
                if(response.friend ===null)
                {
                    this.recommender.isModify = true;
                }   
                this.isLoading = false;     
            }catch(error){
                console.log(error);               
            }
        },  
        async editInfo()
        {
            let formData = new FormData();
            formData.append("user_id", this.$store.getters.currentUser.id);
            formData.append("nic", this.user_nic.val);
            formData.append('password',this.password.val);
            formData.append('password_confirmation',this.password_confirmation.val);
            
            if(this.recommender.val !==null)
            {
                formData.append('recommender',this.recommender.val);
            }
            formData.append('profile_photo',this.image1);   

            // const formData = {               
            //     user_id:this.$store.getters.currentUser.id,  
            //     nic:this.user_nic.val, 
            //     password:this.password.val,
            //     password_confirmation:this.password_confirmation.val,
            //     recommender:this.recommender.val,
            //     profile_photo:this.image1       
            // }
            try {
               const response = await this.$store.dispatch("users/updateProfile", formData);               
                console.log(response);   
                if(response.user){
                    this.$store.commit('updateUserPoint',response.user);  
                }  
                this.recommender.val = response.friend; 
                if(response.friend ===null)
                {
                    this.recommender.isModify = true;
                }else{
                    this.recommender.isModify = false;    
                }  
                this.$flashMessage.show({
                    type: response.state_code!==201?"error":"info",
                    title: response.message,
                    message: response.message,
                });   

            }catch(error){
                console.log(error);               
            }   
        }      
    }
}